import { authRestoreToken } from '../../app/shared/utils';
import { ApolloLink } from '@apollo/client/core';

const authWare = new ApolloLink((operation, forward) => {
  const context = operation.getContext();
  if (!context.headers) {
    context.headers = {};
  }

  const authData = authRestoreToken();
  if (authData) {
    const auth = authRestoreToken();
    const authToken = auth ? auth.token : null;
    if (authToken) {
      context.headers['authorization'] = `Bearer ${authToken}`;
    }
  }

  operation.setContext(context);

  return forward(operation);
});

export default authWare;
